/**
 * @file 用户点击质押按钮后的流程控制
 */
import { TipModal } from '@/components';
import { ConfirmModal } from './confirm';
import { OrderResultModal } from './orderResult';
import { Process, GasStore } from '@/types/stake';
import { CoinInfo } from '@/types/common';
import { useFm } from '@web3/base-hooks';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';
import { scTrack } from '@web3/base-tracking';
import { Event } from '@/config/track-config';
import styles from './index.module.scss';
interface Props {
  aprPerDay: string;
  process: Process;
  slippage: string;
  stakeAmount: string;
  currentStakeToken: CoinInfo;
  gasStore: GasStore;
  confirmButtonIsLoading: boolean;
  confirmButtonText: string;
  orderCode: string;
  stakeLpInfo: Partial<CoinInfo>;
  beginStake: () => Promise<void>;
  onChangeProcess: (v: Process) => void;
}

export const StakeProcess = (props: Props) => {
  const {
    aprPerDay,
    process,
    stakeAmount,
    slippage,
    gasStore,
    currentStakeToken,
    confirmButtonIsLoading,
    confirmButtonText,
    orderCode,
    stakeLpInfo,
    beginStake,
    onChangeProcess,
  } = props;
  const fm = useFm();

  return (
    <>
      {/* 矿工费超过收益提示弹窗 */}
      {process === Process.GasFeeTip && (
        <TipModal
          show
          data-spm-even={Event.Web3PageView}
          data-spm-data={JSON.stringify({
            page_name: 'StakingWeb_bbSOLSmallincome',
          })}
          onClose={() => onChangeProcess(Process.None)}
          onConfirm={() => {
            scTrack(Event.Web3UserClick, {
              page_name: 'StakingWeb_bbSOLSmallincome',
              button_name: 'Smallincome_confirm',
            });
            onChangeProcess(Process.Confirm);
          }}
          currentBtnProps={styles.currentBtn}
          content={fm('insufficientYieldGasFeeStakingWarning')}
          buttonText={fm('continueStaking')}
        ></TipModal>
      )}
      {/* 质押确认弹窗 */}
      {process === Process.Confirm && (
        <ConfirmModal
          show
          slippage={slippage}
          stakeAmount={stakeAmount}
          currentStakeToken={currentStakeToken}
          gasStore={gasStore}
          aprPerDay={aprPerDay}
          stakeLpInfo={stakeLpInfo}
          onClose={() => onChangeProcess(Process.None)}
          buttonIsLoading={confirmButtonIsLoading}
          confirmButtonText={confirmButtonText}
          beginStake={beginStake}
        />
      )}
      {/* 质押结果弹窗 */}
      {process === Process.Result && (
        <OrderResultModal
          show
          currentStakeToken={currentStakeToken}
          stakeAmount={stakeAmount}
          slippage={slippage}
          stakeLpInfo={stakeLpInfo}
          orderCode={orderCode}
          aprPerDay={aprPerDay}
          gasStore={gasStore}
        />
      )}
    </>
  );
};
